export default "__VITE_ASSET__D25h_I$J__"